import { gql } from '@apollo/client'

const SIMPLE_USER_FRAGMENT = gql`
  fragment SimpleUserFragment on User {
    id
    name
    email
  }
`

export default SIMPLE_USER_FRAGMENT
